import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { SubSink } from 'subsink';

import {
  MerchantBasicDataViewModel,
  MerchantSiteViewModel,
} from '@app/api/marketplace/models';
import { AuthenticationSelectors } from '@authentication/store/authentication.slice';
import { MerchantSiteEditComponent } from '@merchant/components/merchant-site-edit/merchant-site-edit.component';
import {
  MerchantActions,
  MerchantSelectors,
} from '@merchant/store/merchant.slice';
import { ApiErrorResponse } from '@shared/interfaces/api-error-response';

@Component({
  selector: 'app-partner-site',
  templateUrl: './partner-site.component.html',
  styleUrls: ['./partner-site.component.scss'],
})
export class PartnerSiteComponent implements OnInit, OnDestroy {
  @ViewChild(MerchantSiteEditComponent) form!: MerchantSiteEditComponent;

  isLoading$: Observable<boolean> = this.store.select(
    MerchantSelectors.selectSiteLoading
  );
  error$: Observable<ApiErrorResponse | undefined> = this.store.select(
    MerchantSelectors.selectSiteEditError
  );

  basicData$: Observable<MerchantBasicDataViewModel | undefined> =
    this.store.select(MerchantSelectors.selectBasicData);

  private subs = new SubSink();

  constructor(private readonly store: Store, private router: Router) {}

  ngOnInit(): void {
    this.subs.sink = this.store
      .select(AuthenticationSelectors.selectMerchantId)
      .subscribe((merchantId) => {
        if (!merchantId) {
          this.router.navigate(['/telesales/partner-registration'], {
            replaceUrl: true,
          });
        }
      });
  }

  onSubmit(response: { data: MerchantSiteViewModel; isFirstSite: boolean }) {
    this.store.dispatch(
      MerchantActions.createSiteByTelesales.trigger({ site: response.data })
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
